import { useQuery } from '@tanstack/react-query';
import { ordersService } from '@/services/ordersService';
import { queryKeys } from '@/lib/queryKeys';

export const useOrderLineItemsHistory = (orderId: string | undefined) => {
  return useQuery({
    queryKey: queryKeys.orders.lineItemsHistory(orderId ?? ''),
    queryFn: () => {
      if (!orderId) {
        throw new Error('Order ID is required');
      }
      return ordersService.getOrderLineItemsHistory(orderId);
    },
    enabled: Boolean(orderId),
    staleTime: 30_000,
  });
};
